import { Controller } from "@hotwired/stimulus"
import { apiJson, formatApiErrorDetail } from "../lib/api_errore"

// «Invia subito» di Leads.js (POST /api/newsletter/send/:grant_id), dopo la conferma della finestra: toast con l'esito,
// pulsante fermo e con il caricamento finché la richiesta è in volo.
export default class extends Controller {
  static targets = ["apri", "icona", "attesa"]
  static values = { url: String }

  async invia() {
    if (this.inVolo) return
    this.inVolo = true
    this.apriTarget.disabled = true
    this.iconaTarget.hidden = true
    this.attesaTarget.hidden = false
    try {
      const data = await apiJson(this.urlValue, { method: "POST" })
      if (data.sent > 0) window.toast?.success(`Newsletter inviata a ${data.sent} iscritti.`)
      else if (data.already_sent > 0) window.toast?.info("Già inviata a tutti gli iscritti per questa apertura.")
      else window.toast?.info("Nessun destinatario per questo bando.")
      if (data.test_mode_note) window.toast?.message(data.test_mode_note)
    } catch (e) {
      window.toast?.error(e.detail ? formatApiErrorDetail(e.detail) : "Invio non riuscito.")
    } finally {
      this.inVolo = false
      this.apriTarget.disabled = false
      this.iconaTarget.hidden = false
      this.attesaTarget.hidden = true
    }
  }
}
